import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core";
import { LeftPanel, RightPanel } from "./components";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import styles from "./styles";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <>
      <MuiDialogTitle
        disableTypography
        classes={{ root: classes.dialogTitle }}
        {...other}
      >
        <Typography variant="h6" className={classes.title}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
      <div className={classes.grayBar}></div>
    </>
  );
});

const PickupDialog = (props) => {
  const { handleClose, classes, pickupinfo, open } = props;
  const { theme } = props.userData.userProfile || {};
  return (
    <Dialog
      maxWidth={"lg"}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      open={open}
      classes={{ paper: classes.dialog }}
      className={`${classes.dialogWrapper} ${
        theme === "dark" ? "darkTheme" : "lightTheme"
      } `}
    >
      <DialogTitle id="dialog-title" onClose={handleClose}>
        Pickup Information
      </DialogTitle>
      <DialogContent
        classes={{ root: classes.dialogContent }}
        className="customScroll"
      >
        <Grid container spacing={24}>
          <Grid item xs={3}>
            <LeftPanel pickupinfo={pickupinfo} />
          </Grid>
          <Grid item xs={9}>
            <RightPanel pickupinfo={pickupinfo} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogFooter }}>
        <Button
          onClick={handleClose}
          color="primary"
          variant="outlined"
          className={classes.actionButton}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default compose(withUserProfile, withStyles(styles))(PickupDialog);
